import { FileTypes } from 'enums';
import { generic } from 'apis';

const useFileUtils = () => {
    const handleFilePreview = async (file) => {
        let data;
        let type;
        if (file?.file instanceof File) {
            data = await file?.file.arrayBuffer();
        } else if (file?.type === FileTypes.pdf) {
            data = await generic.downloadFile({ FileId: file?.id }, { responseType: 'blob' });
        } else {
            data = await generic.downloadFileAsBase64({ Id: file?.id });
        }

        return { data, type };
    };

    return {
        handleFilePreview
    };
};

export default useFileUtils;
